import React from "react";
import ClinicalReportSection from "./ClinicalReportSection";
import { immunizationRecordConfig } from "./abhaClinicalConfigs";

const ImmunizationRecordSection = ({ patientId, patientData }) => (
  <ClinicalReportSection
    patientId={patientId}
    patientData={patientData}
    config={immunizationRecordConfig}
  />
);

export default ImmunizationRecordSection;
